import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { translate } from "@/i18n";
import { IonIcon, IonLabel, IonPage, IonRouterOutlet, IonTabBar, IonTabButton, IonTabs } from "@ionic/vue";
import { businessOutline, settingsOutline } from "ionicons/icons";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();

function showFooter() {
  if (['/tabs/home', '/tabs/settings'].includes(router.currentRoute.value.path)) return true
  return false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonTabs), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRouterOutlet)),
          (showFooter())
            ? (_openBlock(), _createBlock(_unref(IonTabBar), {
                key: 0,
                slot: "bottom"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonTabButton), {
                    tab: "Home",
                    href: "/tabs/home"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), { icon: _unref(businessOutline) }, null, 8, ["icon"]),
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(translate)("Home")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonTabButton), {
                    tab: "settings",
                    href: "/tabs/settings"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), { icon: _unref(settingsOutline) }, null, 8, ["icon"]),
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(translate)("Settings")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})